import request from '@/router/axios'

export const getList = (current, size, params) => request({
  url: '/api/blade-system/menu/list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const getLazyList = (parentId, params) => request({
  url: '/api/blade-system/menu/lazy-list',
  method: 'get',
  params: {
    ...params,
    parentId,
  },
})

export const getLazyMenuList = (parentId, params) => request({
  url: '/api/blade-system/menu/lazy-menu-list',
  method: 'get',
  params: {
    ...params,
    parentId,
  },
})

export const getMenuList = (current, size, params) => request({
  url: '/api/blade-system/menu/menu-list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const remove = ids => request({
  url: '/api/blade-system/menu/remove',
  method: 'post',
  params: {
    ids,
  },
})

export const add = row => request({
  url: '/api/blade-system/menu/submit',
  method: 'post',
  data: row,
})

export const update = row => request({
  url: '/api/blade-system/menu/submit',
  method: 'post',
  data: row,
})

export const getMenu = id => request({
  url: '/api/blade-system/menu/detail',
  method: 'get',
  params: {
    id,
  },
})

export const getTopMenu = () => request({
  url: '/api/blade-system/menu/top-menu',
  method: 'get',
})

export const getRoutes = topMenuId => request({
  url: '/api/blade-system/menu/routes',
  method: 'get',
  params: {
    topMenuId,
  },
})

export const getButtons = () => request({
  url: '/api/blade-system/menu/buttons',
  method: 'get',
})

export const getMenuTree = parentId => request({
  url: '/api/blade-system/menu/tree',
  method: 'get',
  params: {
    parentId,
  },
})
